import { render, staticRenderFns } from "./CreditReview.vue?vue&type=template&id=667a71e1&scoped=true&"
import script from "./CreditReview.vue?vue&type=script&lang=js&"
export * from "./CreditReview.vue?vue&type=script&lang=js&"
import style0 from "./CreditReview.vue?vue&type=style&index=0&id=667a71e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667a71e1",
  null
  
)

export default component.exports